import script from "./PlaqueReportPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlaqueReportPage.vue?vue&type=script&lang=ts&setup=true"

import "./PlaqueReportPage.vue?vue&type=style&index=0&id=0150d31e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0150d31e"]])

export default __exports__